import React, {useEffect} from 'react';
import {Alert, Button} from '@betareader/design-system';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import Avatar from '../../../../components/avatar/avatar';
import {fetchAbandonedReadersData} from '../../../../modules/report';
import {authUtil} from '../../../../utils';

export const AbandonedReadersReport = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const currentBook = useSelector(state => state.book.currentBook);
  const readerFilters = useSelector(state => state.report.readerFilters);
  const versionFilter = useSelector(state => state.report.versionFilter);
  const data = useSelector(state => state.report.abandonedReadersData);
  const fetching = useSelector(state => state.report.fetchingReadingData);

  useEffect(() => {
    if (!currentBook?._id) return;
    const fetchReport = async () => {
      const idToken = await authUtil.getFreshIdToken();
      if (idToken) {
        dispatch(fetchAbandonedReadersData(idToken, currentBook._id, versionFilter, readerFilters));
      }
    };
    fetchReport();
  }, [currentBook?._id, readerFilters, versionFilter, dispatch]);

  const downloadReport = async () => {
    if (!currentBook?._id) return;
    const idToken = await authUtil.getFreshIdToken();
    if (idToken) {
      dispatch(fetchAbandonedReadersData(idToken, currentBook._id, versionFilter, readerFilters, 'csv'));
    }
  };

  if (fetching) return <p role='status'>{t('Loading')}</p>;
  if (!data) return null;

  const entries = data.versionData?.flatMap(version => version.readerEntries || []) || [];
  return (
    <section aria-label={t('AbandonedReadersReport')}>
      <div style={{display: 'flex', justifyContent: 'flex-end'}}>
        <Button variant='secondary' onClick={downloadReport}>{t('Download')}</Button>
      </div>
      <dl style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '1rem', textAlign: 'center'}}>
        {[
          [t('NotEnoughTime'), data.reasonCount?.no_time ?? 0],
          [t('LostInterest'), data.reasonCount?.lost_interest ?? 0],
          [t('Other'), data.reasonCount?.other ?? 0],
        ].map(([label, count]) => (
          <div key={label}><dt>{label}</dt><dd style={{margin: 0, fontSize: '1.5rem'}}>{count}</dd></div>
        ))}
      </dl>
      {entries.length === 0 ? <Alert>{t('NoReadersFound')}</Alert> : (
        <ul style={{listStyle: 'none', padding: 0, display: 'grid', gap: '1rem'}}>
          {entries.map((entry, index) => (
            <li key={`${entry._id}-${index}`} className='br-card' style={{display: 'flex', gap: '1rem'}}>
              <Avatar diameter={30} name={entry.displayName} />
              <div>
                <strong>{entry.displayName}</strong>
                <p>{moment(entry.abandonedAt).fromNow()} ({t('ReachedPartTitle', {partTitle: entry.exitPartTitle})})</p>
                {entry.feedback && <p>{entry.feedback}</p>}
                <p>{`${t('ReasonToQuit')}: ${t(`reason_${entry.reason}`)}`}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default AbandonedReadersReport;
